import { SolicitacaoExameImagem } from '../../../../atendimento/core/_models'

export type TomSituacao = 'info' | 'success' | 'secondary'

export type RotuloSituacao = {
  chave: string
  tom: TomSituacao
  icone: string
}

export const rotuloSituacao = (
  solicitacao: Pick<SolicitacaoExameImagem, 'situacao' | 'motivoCancelamento'>
): RotuloSituacao => {
  if (solicitacao.situacao === 'AGUARDANDO') {
    return { chave: 'exames_imagem.situacao.aguardando', tom: 'info', icone: 'fas fa-clock' }
  }
  if (solicitacao.situacao === 'RECEBIDO') {
    return {
      chave: 'exames_imagem.situacao.recebido',
      tom: 'success',
      icone: 'fas fa-check-circle',
    }
  }
  switch (solicitacao.motivoCancelamento) {
    case 'SUBSTITUICAO':
      return {
        chave: 'exames_imagem.situacao.substituido',
        tom: 'secondary',
        icone: 'fas fa-exchange-alt',
      }
    case 'ENCERRAMENTO':
      return {
        chave: 'exames_imagem.situacao.encerrado',
        tom: 'secondary',
        icone: 'fas fa-door-closed',
      }
    case 'EXPIRACAO':
      return {
        chave: 'exames_imagem.situacao.expirado',
        tom: 'secondary',
        icone: 'fas fa-hourglass-end',
      }
    default:
      return { chave: 'exames_imagem.situacao.cancelado', tom: 'secondary', icone: 'fas fa-ban' }
  }
}
